import { z } from 'zod';
import { BaseFieldDefinitionSchema } from './base';
export var DateFieldDefinition;
(function (DateFieldDefinition) {
    DateFieldDefinition.TYPE = 'date';
})(DateFieldDefinition || (DateFieldDefinition = {}));
export const DateFieldDefinitionSchema = BaseFieldDefinitionSchema.and(z.object({
    type: z.literal(DateFieldDefinition.TYPE),
    defaultValue: z.string().optional(),
    validations: z
        .object({
        min: z.string().optional(),
        max: z.string().optional()
    })
        .optional()
}));
//# sourceMappingURL=date.js.map